import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { rgba } from 'polished';

import breakpoints from '../styles/breakpoints';
import { placeholder } from '../media/images';

const StyledPostPreview = styled(Link)`
  text-decoration: none;
  padding: 0 15px 30px;
  flex: 0 0 100%;

  ${breakpoints.medium`
    padding: 0 5px 54px;
	flex: 0 0 50%;
  `};

  ${breakpoints.large`
	padding: 0 20px 100px;
	flex: 0 0 33.33%;
	max-width: 33.33%;
  `};
`;

const Thumbnail = styled.div`
  background-image: url(${p => (p.src ? p.src : placeholder)});
  background-size: cover;
  background-position: 50% 50%;
  width: 100%;
  height: 0;
  padding-bottom: 81.06%;
  margin-bottom: 20px;
  position: relative;

  &:hover {
    &:after {
      opacity: 1;
    }
  }

  &:after {
    align-items: center;
    background-color: ${p => rgba(p.theme.colors.black, 0.3)};
    color: ${p => p.theme.colors.white};
    content: 'Les mer';
    display: flex;
    font-size: 0.75rem;
    justify-content: center;
    opacity: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition: opacity 0.5s;
    text-transform: uppercase;
  }
`;

const Title = styled.h2`
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.6;
  letter-spacing: 0.3px;
  margin-bottom: 0;

  ${breakpoints.medium`
    font-size: 1.25rem;
  `};

  ${breakpoints.large`
    font-size: 1.5625rem;
    margin-bottom: 10px;
  `};
`;

const ReadMore = styled.p`
  border-bottom: 1px solid ${p => p.theme.colors.primary};
  color: ${p => p.theme.colors.lightFont};
  display: inline-block;
  font-size: 1rem;
  font-weight: 500;
  padding-bottom: 2px;
  text-decoration: none;
  transition: border-color 0.5s, padding 0.2s;

  ${breakpoints.large`
    font-size: 1.125rem;
  `};

  &:hover {
    border-color: ${p => p.theme.colors.black};
    padding-bottom: 0;
  }
`;

export default function PostPreview({ id, thumbnail, title }) {
  return (
    <StyledPostPreview to={`${id}`}>
      <Thumbnail src={thumbnail} />

      <Title>{title}</Title>

      <ReadMore>Les mer</ReadMore>
    </StyledPostPreview>
  );
}

PostPreview.propTypes = {
  id: PropTypes.number.isRequired,
  thumbnail: PropTypes.string,
  title: PropTypes.string.isRequired
};
